import { render, staticRenderFns } from "./index.vue?vue&type=template&id=050ca28e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ca28e",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WCategories from '@/components/WCategories.vue'
import WLoading from '@/components/WLoading.vue'
import WTopBar from '@/components/WTopBar.vue'
autoInstallComponents(component, {WCategories,WLoading,WTopBar})
